import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getInspectionTemplates } from "../services/InspectionTemplatesAPI";


export interface InspectionTemplate {
    id: number;
    description: string;
    categoryID: number;
    categoryDescription: string;
    tenant_ID: number;
    moduleList_V2: any[];
}

export interface InspectionTemplatesState {
    inspectionTemplates: InspectionTemplate[];
    loading: boolean;
    error: string | null;
}

const initialState: InspectionTemplatesState = {
    inspectionTemplates: [],
    loading: false,
    error: null,
};

export const fetchInspectionTemplates = createAsyncThunk<
    InspectionTemplate[],
    { token: string },
    { rejectValue: string }
>(
    "workOrders/GetInspectionTemplates",
    async ({ token }, { rejectWithValue }) => {
        try {
            const inspectionTemplates = await getInspectionTemplates(token);
            return inspectionTemplates;
        } catch (error) {
            console.log("[Error in Fetching inspection templates]:: ", error);
            return rejectWithValue("Failed to fetch inspection templates");
        }
    }
);

const inspectionTemplatesSlice = createSlice({
    name: "inspectionTemplates",
    initialState,
    reducers: {
        removeInspectionTemplates: (state) => {
            state.inspectionTemplates = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInspectionTemplates.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                fetchInspectionTemplates.fulfilled,
                (state, action: PayloadAction<InspectionTemplate[]>) => {
                    state.loading = false;
                    state.inspectionTemplates = action.payload;
                }
            )
            .addCase(fetchInspectionTemplates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { removeInspectionTemplates } = inspectionTemplatesSlice.actions;
export default inspectionTemplatesSlice.reducer;
